import type { FC } from 'react';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

import './styles/styles.css';
import Header from '../../Header';
import { RoomsTable } from '../../Tables/Rooms';

export const Rooms: FC = () => {
  return (
    <Container fluid className="reservation-list-container">
      <Header title="Rooms" />
      <RoomsTable />
    </Container>
  );
};
